import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { useNavigate } from 'react-router-dom';
import BrokersImg from 'Assets/Images/brokers.png'
const Brokers = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const navigate = useNavigate();
    useEffect(() => {
        if (currentLang !== 'fa') {
            navigate('/');;
        }
    }, [currentLang, navigate]);
    const content = {
        fa: {
            description: (
                <>
                    در این قسمت می‌توانید <strong className="fw-bold">لیست کارگزاران عضو بورس انرژی ایران</strong> را به همراه موارد زیر مشاهده‌کنید:
                </>
            ),
            list: [
                "نام شرکت کارگزاری",
                "نشانی دفتر مرکزی",
                "تلفن دفتر مرکزی",
                "تلفن واحد انرژی",
                "وضعیت مجوز"
            ],
        },

        en: {
            description: (
                <>
                    Here you can view the <strong className="fw-bold">List of Brokerage Firms Admitted to the Iran Energy Exchange</strong> along with the following items:
                </>
            ),
            list: [
                "Brokerage Company Name",
                "Head Office Address",
                "Head Office Phone Number",
                "Energy Department Phone Number",
                "License Status"
            ],
        },

        ar: {
            description: (
                <>
                    يمكنك هنا مشاهدة <strong className="fw-bold">قائمة الوسطاء الأعضاء في بورصة الطاقة الإيرانية</strong> مع البنود التالية:
                </>
            ),
            list: [
                "اسم شركة الوساطة",
                "عنوان المكتب الرئيسي",
                "هاتف المكتب الرئيسي",
                "هاتف قسم الطاقة",
                "حالة الترخيص"
            ],
        },
    };

    const { description, list } = content[currentLang] || content.fa; // fallback to fa

    return (
        <div className="megaMenuContent">
            <div className="row">
                <div className="col-6">
                    <div className="row justify-content-between h-100">
                        <div className="col-12">
                            <p>{description}</p>
                            <ul className="IeeStatuteList">
                                {list.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>

                        </div>
                        <div className="col-12 d-flex align-items-end">
                            <a href="/Market/Brokers" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                                {t("view_list")}
                                <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                                    {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                                </span>
                            </a>

                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <img src={BrokersImg} className="w-100" />
                </div>
            </div>
        </div>
    );
};

export default Brokers;
